import "./CreateDesign.css";
import "react-quill/dist/quill.snow.css";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
} from "@mui/material";
import { Layer, Line, Rect, Stage } from "react-konva";
import { useEffect, useRef, useState } from "react";

import BreadcrumbsNavigation from "../../../components/Breadcrumbs/BreadcrumbsNavigation";
import CancelDialog from "../../../components/CancelDialog/CancelDialog";
import CircleLoading from "../../../components/misc/CircleLoading/CircleLoading";
import CloseIcon from "@mui/icons-material/Close";
import CreateDesignOnboarding from "./CreateDesignOnboarding";
import EditorFunctionality from "../../../components/CreateDesignEditor/EditorFunctionality";
import IconButton from "@mui/material/IconButton";
import { OnboardingEmitter } from "../../../misc/onboardingEmitter";
import STATIC_ROUTES from "../../../misc/Static_routes";
import ShareBtnDesktopAnimated from "../../../components/Buttons/ShareBtnDesktopAnimated/ShareBtnDesktopAnimated";
import URLImage from "../../../components/URLImage/URLImage";
import { UrbanGreenEco } from "../../../misc/Static_design_elements";
import { categoryIcon } from "../../../utils/createDesignHelper";
import { categoryService } from "../../../services/categoryService";
import { createDesign } from "../../../services/designService";
import downloadIcon from "../../../assets/images/downloadIcon.svg";
import { getPinById } from "../../../services/pinsService";
import newDesignIcon from "../../../assets/images/newDesignIcon.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const maxStep = 4;

const CreateDesign = () => {
  const { t } = useTranslation();

  const params = useParams();
  const navigate = useNavigate();
  const [pin, setPin] = useState("");
  const [filteredElements, setFilteredElements] = useState(UrbanGreenEco);
  const [title, setTitle] = useState("");
  const [comment, setComment] = useState("");
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [sex, setSex] = useState("");
  const [email, setEmail] = useState("");
  const [titleError, setTitleError] = useState("");
  const [nameError, setNameError] = useState("");
  const [ageError, setAgeError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [designStep, setDesignStep] = useState(1);
  const [images, setImages] = useState([]);
  const [bg, setBg] = useState("");
  const [konvaListening, setKonvaListening] = useState(true);
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [disabledPublishBtn, setDisabledPublishBtn] = useState(false);
  const [disabledNextBtn, setDisabledNextBtn] = useState(false);
  const [selectedId, selectShapeId] = useState(null);
  const [selectedShape, setSelectedShape] = useState(null);
  const [city, setCity] = useState();
  const [newUriDesign, setNewUriDesign] = useState(null);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [tool, setTool] = useState("pen");
  const [lines, setLines] = useState([]);
  const isDrawing = useRef(false);
  const [penIsDisabled, setPenIsDisabled] = useState(true);
  const [eraserIsDisabled, setEraserIsDisabled] = useState(true);
  const [requiredFieldsDialog, setRequiredFieldsDialog] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [thumbnail, setThumbnail] = useState();
  const [runOnboarding, setRunOnboarding] = useState(false);
  const cancelDialogTitle = "Are you sure you want to go back to all designs?";
  const cancelDialogSubtitle = "*Your change wouldn't be saved!";
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [currentSelectedImageElement, setCurrentSelectedImageElement] = useState(null);

  const dragUrl = useRef();
  const stageRef = useRef();
  const fileInput = useRef();

  const {
    isLoading,
    data: categories,
    isFetching,
  } = useQuery({
    queryKey: ["categories"],
    queryFn: () => categoryService.getAllCategories(),
  });

  useEffect(() => {
    const data = getPinById(params.pinID);
    data.then((values) => {
      setPin(values.pin);
      setCity(values.pin.city);
      const img = new window.Image();
      img.src = values?.pin?.image;
      img.onload = () => {
        setBg(img);
      };
    });
  }, []);

  useEffect(() => {
    if (categories) {
      setFirstCategory();
    }
  }, [categories]);

  useEffect(() => {
    OnboardingEmitter.subscribe("startOnboarding", (event) => {
      setRunOnboarding(event);
      addElementToCanvas();
    });
    return () => OnboardingEmitter.unsubscribe();
  }, [OnboardingEmitter]);

  const setRunDefault = (isLast) => {
    if (isLast) {
      setRunOnboarding(false);
    }
  };

  const navigateToProduct = () => {
    if (!currentSelectedImageElement?.link) return;
    window.open(currentSelectedImageElement?.link, "_blank");
  };

  const onClickInfoBtn = (imageSrc) => {
    if (!imageSrc) return
    const foundElement = filteredElements?.elements?.find(el => el.image === imageSrc);

    if (!foundElement) return
    setCurrentSelectedImageElement(foundElement);
    setOpenInfoDialog(true);
    console.log(foundElement);

    //TODO WHEN SELECTING IMAGE APPEND TO selectedShape the img title from database, description and prodictLink
    //so they can be visible in the dialog and clickable
  };

  const addElementToCanvas = () => {
    const pos = { x: 500, y: 400 };
    if (window.innerWidth <= 480) {
      pos.x = window.screen.width / 2;
      pos.y = window.screen.height / 6;
    } else if (window.innerWidth > 480 && window.innerWidth < 1100) {
      pos.x = window.screen.width / 2 - 50;
      pos.y = window.screen.height / 3;
    } else {
      pos.x = 100;
      pos.y = 250;
    }
    const id = `image-${Date.now()}`;
    setImages((prevImages) => [
      ...prevImages,
      {
        id,
        x: pos.x,
        y: pos.y,
        src: filteredElements[6]?.image,
        width: 100, // Initial width
        height: 100, // Initial height
        rotation: 0, // Initial rotation
        scaleX: 1,
      },
    ]);
  };

  const setFirstCategory = () => {
    setFilteredElements(categories[0]);
    const firstCategory = document.querySelectorAll(".group-element")[0];
    if (firstCategory) {
      firstCategory.classList.add("selected");
    }
  };

  const onClickGroupElements = (e, group) => {
    const removeClass = document.querySelectorAll(".group-element");
    removeClass.forEach((element) => {
      element.classList.remove("selected");
    });
    e.currentTarget.classList.add("selected");
    setFilteredElements(group);
  };

  const handleTitleInputChange = (e) => {
    const inputValue = e.target.value;
    const isString = /^[+-]?\d+(\.\d+)?$/.test(inputValue);

    if (isString && isString) {
      setTitleError(t("wrongTextFormat"));
      setDisabledNextBtn(true);
    } else {
      setTitleError("");
      setDisabledNextBtn(false);
    }

    setTitle(e.target.value);
  };

  const handleNameInputChange = (e) => {
    const inputValue = e.target.value;
    const isString = /^[+-]?\d+(\.\d+)?$/.test(inputValue);

    if (isString) {
      setNameError(t("wrongTextFormat"));
      setDisabledPublishBtn(true);
    } else {
      setNameError("");
      setDisabledPublishBtn(false);
    }
    setName(e.target.value);
  };

  const handeAgeInputChange = (e) => {
    const inputValue = e.target.value;
    const isValidNumber = /^[+-]?\d+(\.\d+)?$/.test(inputValue);

    if (!isValidNumber && inputValue) {
      setAgeError(t("wrongNumberFormat"));
      setDisabledPublishBtn(true);
    } else if (!inputValue) {
      setAgeError("");
      setDisabledPublishBtn(false);
    } else {
      if (inputValue > 0 && inputValue < 100) {
        setAgeError("");
        setDisabledPublishBtn(false);
      } else {
        setAgeError(t("ageRange0-99"));
        setDisabledPublishBtn(true);
      }
    }

    setAge(e.target.value);
  };

  const handeEmailInputChange = (e) => {
    const email = e.target.value;
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    const isValidEmail = emailRegex.test(email);

    if (!isValidEmail && email) {
      setEmailError(t("WrongEmailFormat"));
      setDisabledPublishBtn(true);
    } else {
      setEmailError("");
      setDisabledPublishBtn(false);
    }
    setEmail(e.target.value);
  };

  const handeSexSelectChange = (e) => {
    const sex = e.target.value;
    setSex(sex);
  };

  const onClickPrevStep = () => {
    if (designStep > 1) {
      setDesignStep((prevState) => prevState - 1);
      if (designStep === 2) {
        setDrawerOpen(false);
      }
      if (designStep - 1 === 1) {
        setNewUriDesign(null);
      }
      setKonvaListening(true);
    }
  };

  const onClickNextStep = () => {
    if (designStep < maxStep - 1) {
      selectShapeId(null);
      setSelectedShape(null);
      setTimeout(async () => {
        if (!newUriDesign) {
          const currentUri = stageRef.current.toDataURL();
          resizeThumbnailAndUri(currentUri);
        }
      }, 100);
      setDesignStep((prevState) => prevState + 1);
    }
  };

  const resizeThumbnailAndUri = (uri) => {
    const img = new window.Image();
    img.onload = function () {
      const cvs5 = document.createElement("canvas");
      const ctx = cvs5.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const width = bg.width;
      const height = bg.height;
      cvs5.width = width;
      cvs5.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      cvs5.getContext("2d").drawImage(img, 0, 0, width, height);
      setNewUriDesign(cvs5.toDataURL("image/png"));
      setThumbnail(cvs5.toDataURL("image/png"));
    };
    img.src = uri;
  };

  const onClickNewDesign = () => {
    setDesignStep(1);
    setTitle("");
    setComment("");
    setName("");
    setAge("");
    setSex("");
    setEmail("");
    setImages([]);
    setNewUriDesign(null);
    setDisabledNextBtn(false);
    setKonvaListening(true);
    OnboardingEmitter.dispatch("showOnboarding", true);
  };

  const handleDownload = () => {
    const uri = newUriDesign;
    const link = document.createElement("a");
    link.href = uri;
    link.download = "image.jpeg"; // Set the desired filename here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCreateDesign = async () => {
    // if (!isAnonymous && (age === "" || sex === "")) {
    //   setRequiredFieldsDialog(true);
    //   return;
    // }

    const data = {
      pin_id: pin.id,
      title,
      comment,
      name: isAnonymous ? "" : name,
      age: isAnonymous ? "" : age,
      sex: isAnonymous ? "" : sex,
      email: isAnonymous ? "" : email,
      image: newUriDesign,
      isAnonymous,
      thumbnail,
    };
    setTitle("");
    setComment("");
    setName("");
    setAge("");
    setSex("");
    setEmail("");
    setIsAnonymous(false);
    setDisabledNextBtn(false);

    if (designStep < maxStep) {
      setDesignStep((prevState) => prevState + 1);
    }
    setDrawerOpen(false);
    setKonvaListening(false);
    await createDesign(data, t);
    OnboardingEmitter.dispatch("hideOnboarding", true);
  };

  const checkDeselect = (e) => {
    if (e.target.attrs.id === "main-board") {
      selectShapeId(null);
      setSelectedShape(null);
    } else {
      if (e.target.attrs.id !== "pen-line") {
        setPenIsDisabled(true);
        setEraserIsDisabled(true);
        setSelectedShape(e.target);
      }
    }

    handleMouseDown(e);
  };

  const deleteElement = () => {
    if (selectedId !== null) {
      const newImages = images.slice();
      const index = newImages.findIndex((img) => img.id === selectedId);
      newImages.splice(index, 1);
      setImages(newImages);
      selectShapeId(null);
      setSelectedShape(null);
    }
  };

  const handleErase = () => {
    setPenIsDisabled(true);
    setEraserIsDisabled(!eraserIsDisabled);
    setTool("eraser");
  };

  const duplicateElement = () => {
    if (selectedId !== null) {
      const newImages = [...images];
      const index = newImages.findIndex((img) => img.id === selectedId);
      const findImage = { ...newImages[index] };
      findImage.x = findImage.x + 20;
      findImage.y = findImage.y + 20;
      findImage.id = `image-${Date.now()}`;
      selectShapeId(findImage.id);
      setSelectedShape(findImage);
      newImages.push(findImage);
      setImages(newImages);
    }
  };

  const handleFlip = () => {
    if (selectedId !== null) {
      const newImages = images.slice();
      const index = newImages.findIndex((img) => img.id === selectedId);
      const findImage = newImages[index];
      findImage.scaleX = -findImage.scaleX;
      setImages(newImages);
    }
  };

  const handlePen = () => {
    setEraserIsDisabled(true);
    setPenIsDisabled(!penIsDisabled);
    setTool("pen");
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = function () {
        const base64String = reader.result.split(",")[1];

        const id = `image-${Date.now()}`;
        setImages((prevImages) => [
          ...prevImages,
          {
            id,
            x: bg.width / 2,
            y: bg.height / 2,
            src: "data:image/jpeg;base64," + base64String,
            width: 100, // Initial width
            height: 100, // Initial height
            rotation: 0, // Initial rotation
            scaleX: 1,
          },
        ]);
        setSelectedShape({
          id,
          x: bg.width / 2,
          y: bg.height / 2,
          src: "data:image/jpeg;base64," + base64String,
          width: 100, // Initial width
          height: 100, // Initial height
          rotation: 0, // Initial rotation
          scaleX: 1,
        });
        selectShapeId(id);
      };

      reader.readAsDataURL(file);
    }
  };

  const clearFileInput = () => {
    fileInput.current.value = "";
  };

  const handleMouseDown = (e) => {
    if (!penIsDisabled || !eraserIsDisabled) {
      isDrawing.current = true;
      const pos = e?.target.getStage().getPointerPosition();
      setLines([...lines, { tool, points: [pos.x, pos.y] }]);
    }
  };

  const dialogActionHandler = () => {
    navigate(`/${city?.name}/${pin?.id}`);
  };

  const handleMouseMove = (e) => {
    if (!penIsDisabled || !eraserIsDisabled) {
      // no drawing - skipping
      if (!isDrawing.current) {
        return;
      }
      const stage = e.target.getStage();
      const point = stage.getPointerPosition();
      let lastLine = lines[lines.length - 1];
      // add point
      lastLine.points = lastLine.points.concat([point.x, point.y]);

      // replace last
      lines.splice(lines.length - 1, 1, lastLine);
      setLines(lines.concat());
    }
  };

  const handleMouseUp = () => {
    isDrawing.current = false;
  };

  const toggleDrawer = (open) => (event) => {
    setDrawerOpen(open);
    onClickNextStep();
    if (!open) {
      setDesignStep(1);
      setNewUriDesign(null);
    }
  };

  return (
    <div className="create_design_wrapper">
      {isLoading || isFetching ? (
        <p className="loading">
          <CircleLoading />
        </p>
      ) : (
        <div className="create-design">
          <CreateDesignOnboarding
            run={runOnboarding}
            setRunDefault={setRunDefault}
          ></CreateDesignOnboarding>
          <div
            className={
              designStep === maxStep ? "main-board dir-row" : "main-board"
            }
          >
            {designStep === maxStep && (
              <>
                <div className="titles_wrapper_main px-2">
                  <div className="title_small">CoTown</div>
                  <div className="title_large">
                    <span className="title_word_background_line_wrapper">
                      {" "}
                      <span className="title_word_background_line"></span>
                      THANK YOU
                    </span>
                    {" " + "FOR YOUR DESIGN"}
                  </div>
                </div>
                <div className="breadcrumbs_container br_crumb_desk">
                  <BreadcrumbsNavigation
                    locations={[
                      { link: STATIC_ROUTES.home, name: "Cotown Map" },
                      { link: `/${pin?.city?.name}`, name: pin?.city?.name },
                      {
                        link: `/${pin?.city?.name}/${pin?.id}`,
                        name: pin?.name,
                      },
                    ]}
                    withoutLastHighlighed={true}
                  ></BreadcrumbsNavigation>
                </div>
              </>
            )}
            {designStep !== maxStep && <></>}

            {
              <div
                onDrop={(e) => {
                  e.preventDefault();
                  stageRef.current.setPointersPositions(e);
                  const pos = stageRef.current.getPointerPosition();
                  const id = `image-${Date.now()}`;
                  console.log(stageRef.current);
                  const newImg = {
                    id,
                    x: pos.x,
                    y: pos.y,
                    src: dragUrl.current,
                    width: 100, // Initial width
                    height: 100, // Initial height
                    rotation: 0, // Initial rotation
                    scaleX: 1,
                  };
                  setImages((prevImages) => [...prevImages, newImg]);
                  const imgWithAttrs = {
                    attrs: newImg,
                  };
                  selectShapeId(id);
                  setSelectedShape(imgWithAttrs);
                  setPenIsDisabled(true);
                  setEraserIsDisabled(true);
                }}
                onDragOver={(e) => e.preventDefault()}
                style={{ width: "100%" }}
              >
                {window.matchMedia("(min-width: 480px)").matches && (
                  <div className="stage_wrapper_desk">
                    <div
                      className={
                        designStep === maxStep
                          ? "final_step_thumbnail_wrapper_desk"
                          : ""
                      }
                    >
                      <Stage
                        width={bg?.width}
                        height={bg?.height}
                        ref={stageRef}
                        listening={konvaListening}
                        onTouchMove={handleMouseMove}
                        onTouchEnd={handleMouseUp}
                        onMouseDown={checkDeselect}
                        onTouchStart={checkDeselect}
                        onMousemove={handleMouseMove}
                        onMouseup={handleMouseUp}
                      >
                        <Layer>
                          <Rect
                            id="main-board"
                            width={bg?.width}
                            height={bg?.height}
                            fillPatternRepeat="no-repeat"
                            fillPatternImage={bg}
                          ></Rect>

                          {images?.map((image, i) => {
                            return (
                              <URLImage
                                key={image.id}
                                image={image}
                                isSelected={image.id === selectedId}
                                selectedShape={selectedShape}
                                onClickInfoBtn={() => onClickInfoBtn(image?.src)}
                                scaleX={1}
                                scaleY={1}
                                stageRef={stageRef}
                                currentItem={filteredElements?.elements?.find(el => el?.image === image?.src)}
                                onSelect={(e) => {
                                  selectShapeId(image.id);
                                  setSelectedShape(e?.target);
                                }}
                                onDragStart={(e) => {
                                  const newImages = images.slice();
                                  const index = newImages.findIndex(
                                    (img) => img.id === image.id
                                  );
                                  const findImage = newImages[index];
                                  // remove from the list:
                                  newImages.splice(index, 1);
                                  // add to the top
                                  newImages.push(findImage);
                                  setImages(newImages);
                                  selectShapeId(image.id);
                                  setSelectedShape(e.target);
                                }}
                                onChange={(newAttrs) => {
                                  const newImages = images.slice();
                                  const index = newImages.findIndex(
                                    (img) => img.id === image.id
                                  );
                                  newImages[index] = newAttrs;
                                  setImages(newImages);
                                }}
                                onTransformEnd={(newAttrs) => {
                                  const newImages = images.slice();
                                  const index = newImages.findIndex(
                                    (img) => img.id === image.id
                                  );
                                  newImages[index] = newAttrs;
                                  setImages(newImages);
                                }}
                              />
                            );
                          })}
                        </Layer>

                        <Layer>
                          {lines.map((line, i) => (
                            <Line
                              id="pen-line"
                              key={i}
                              points={line.points}
                              stroke="blue"
                              strokeWidth={line.tool === "eraser" ? 50 : 5}
                              tension={0.5}
                              lineCap="round"
                              lineJoin="round"
                              globalCompositeOperation={
                                line.tool === "eraser"
                                  ? "destination-out"
                                  : "source-over"
                              }
                            />
                          ))}
                        </Layer>
                      </Stage>
                    </div>
                    <div
                      className={
                        designStep === maxStep
                          ? "editor_func_desk hidden_editor"
                          : "editor_func_desk"
                      }
                    >
                      <EditorFunctionality
                        duplicateElement={duplicateElement}
                        handleFlip={handleFlip}
                        handleErase={handleErase}
                        handlePen={handlePen}
                        deleteElement={deleteElement}
                        handleOpenDrawer={toggleDrawer(true)}
                        handleOpenDialog={() => setOpenCancelDialog(true)}
                      ></EditorFunctionality>
                    </div>
                  </div>
                )}
                {window.matchMedia("(max-width: 479px)").matches && (
                  <div className="stage_wrapper_mob">
                    <div
                      className={
                        designStep === maxStep
                          ? "final_step_thumbnail_wrapper_mob"
                          : ""
                      }
                    >
                      <Stage
                        width={window.innerWidth}
                        height={(window.innerWidth * 720) / 540 / 2.31}
                        style={{ width: "100%", margin: "auto" }}
                        ref={stageRef}
                        listening={konvaListening}
                        onTouchMove={handleMouseMove}
                        onTouchEnd={handleMouseUp}
                        onMouseDown={checkDeselect}
                        onTouchStart={checkDeselect}
                        onMousemove={handleMouseMove}
                        onMouseup={handleMouseUp}
                      >
                        <Layer width={bg?.width} height={bg?.height / 3}>
                          <Rect
                            id="main-board"
                            width={bg?.width}
                            height={bg.height}
                            fillPatternRepeat="no-repeat"
                            fillPatternImage={bg}
                            fillPatternScaleX={window.innerWidth / bg.width}
                            fillPatternScaleY={
                              (window.innerWidth / bg.width) *
                              (bg.height / bg.width)
                            }
                          ></Rect>

                          {images?.map((image, i) => {
                            return (
                              <URLImage
                                key={image.id}
                                image={image}
                                isSelected={image.id === selectedId}
                                scaleX={1}
                                stageRef={stageRef}
                                onClickInfoBtn={() => onClickInfoBtn(image?.src)}
                                currentItem={filteredElements?.elements?.find(el => el?.image === image?.src)}
                                selectedShape={selectedShape}
                                onSelect={() => {
                                  selectShapeId(image.id);
                                }}
                                onDragStart={() => {
                                  const newImages = images.slice();
                                  const index = newImages.findIndex(
                                    (img) => img.id === image.id
                                  );
                                  const findImage = newImages[index];
                                  // remove from the list:
                                  newImages.splice(index, 1);
                                  // add to the top
                                  newImages.push(findImage);
                                  setImages(newImages);

                                  selectShapeId(image.id);
                                }}
                                onChange={(newAttrs) => {
                                  const newImages = images.slice();
                                  const index = newImages.findIndex(
                                    (img) => img.id === image.id
                                  );
                                  newImages[index] = newAttrs;
                                  setImages(newImages);
                                }}
                                onTransformEnd={(newAttrs) => {
                                  // const newImages = images.slice();
                                  // const index = newImages.findIndex(
                                  //   (img) => img.id === image.id
                                  // );
                                  // newImages[index] = newAttrs;
                                  // setImages(newImages);
                                }}
                              />
                            );
                          })}
                        </Layer>

                        <Layer>
                          {lines.map((line, i) => (
                            <Line
                              key={i}
                              points={line.points}
                              stroke="blue"
                              strokeWidth={line.tool === "eraser" ? 50 : 5}
                              tension={0.5}
                              lineCap="round"
                              lineJoin="round"
                              globalCompositeOperation={
                                line.tool === "eraser"
                                  ? "destination-out"
                                  : "source-over"
                              }
                            />
                          ))}
                        </Layer>
                      </Stage>
                    </div>
                  </div>
                )}
              </div>
            }
            {designStep === 1 && (
              <div className="dragging-zone">
                <div className="editor_func_mobile">
                  <EditorFunctionality
                    duplicateElement={duplicateElement}
                    handleFlip={handleFlip}
                    handleErase={handleErase}
                    handlePen={handlePen}
                    deleteElement={deleteElement}
                    handleOpenDrawer={toggleDrawer(true)}
                    handleOpenDialog={() => setOpenCancelDialog(true)}
                  ></EditorFunctionality>
                </div>

                <div className="horizontal_line"></div>
                <div className="elements">
                  {filteredElements?.elements?.map((item, index) => {
                    return (
                      <div key={index} className="dragging-element">
                        <img
                          src={item.image}
                          alt={item.name}
                          draggable={item.isDraggable}
                          onDragStart={(e) => {
                            dragUrl.current = e.target.src;
                          }}
                          onClick={(e) => {
                            if (
                              window.matchMedia("(max-width: 1400px)").matches
                            ) {
                              dragUrl.current = e.target.src;
                              e.preventDefault();
                              stageRef.current.setPointersPositions(e);
                              const pos = stageRef.current.getPointerPosition();

                              const id = `image-${Date.now()}`;
                              const img = {
                                id,
                                x: window.screen.width / 1.2 / 2,
                                y: window.screen.height / 3 / 2,
                                src: e.target.src,
                                width: 100, // Initial width
                                height: 100, // Initial height
                                rotation: 0, // Initial rotation
                                scaleX: 1,
                              };
                              setImages((prevImages) => [...prevImages, img]);
                              selectShapeId(id);
                              const imgWithAttrs = {
                                attrs: img,
                              };
                              setSelectedShape(imgWithAttrs);
                            }
                          }}
                        />
                        {item.logo && (
                          <img
                            className="element-logo"
                            src={item.logo}
                            alt={item.name}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className="horizontal_line"></div>
                <div className="vertical_line_create"></div>
                <div className="group-elements">
                  {/* <div
                    className="go_back_btn_cr_design"
                    onClick={() => setOpenCancelDialog(true)}
                  >
                    <span style={{ paddingLeft: "10px" }}>&#60;</span>{" "}
                    <span style={{ paddingLeft: "10px" }}>Go Back</span>
                  </div> */}
                  {categories?.map((category) => {
                    return (
                      <div
                        key={category.name}
                        className="group-element"
                        onClick={(e) => onClickGroupElements(e, category)}
                      >
                        {categoryIcon(category.name)}
                        <span className="group-element-title">
                          {t(category.name)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {designStep === 4 && (
              <div className="new_des_buttons_wrapper">
                <div className="new_des_action_btns">
                  <button
                    className="download_btn_final_step aligned_text"
                    onClick={handleDownload}
                  >
                    <img src={downloadIcon} alt="Download Icon" />
                    <span>{t("download")}</span>
                  </button>

                  <button
                    className="new_design_final_step aligned_text"
                    onClick={() => onClickNewDesign()}
                  >
                    <img src={newDesignIcon} alt="New Design Icon" />
                    Make a new design
                  </button>
                </div>

                <div className="social-network-btns-wrapper">
                  <ShareBtnDesktopAnimated
                    facebookUrl={`${process.env.REACT_APP_BASE_URL}/app/pin/${pin.pin_id}/create-design`}
                  ></ShareBtnDesktopAnimated>
                </div>
              </div>
            )}
          </div>

          <CancelDialog
            openCancelDialog={openCancelDialog}
            setOpenCancelDialog={setOpenCancelDialog}
            dialogActionHandler={dialogActionHandler}
            cancelDialogTitle={cancelDialogTitle}
            cancelDialogSubtitle={cancelDialogSubtitle}
          ></CancelDialog>

          <Dialog
            open={requiredFieldsDialog}
            onClose={() => setRequiredFieldsDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Required fields</DialogTitle>

            <DialogContent>{t("pleaseFillData")}</DialogContent>

            <DialogActions sx={{ margin: "0px 15px" }}>
              <Button
                onClick={() => setRequiredFieldsDialog(false)}
                autoFocus
                variant="contained"
                color="info"
              >
                {t("ok")}
              </Button>
            </DialogActions>
          </Dialog>

          <Drawer
            PaperProps={{
              sx: {
                width: window.matchMedia("(min-width: 1100px)").matches
                  ? "80%"
                  : "100%",
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
                margin: "auto",
              },
            }}
            anchor={"bottom"}
            open={drawerOpen}
            onClose={toggleDrawer(false)}
          >
            <div className="thumbnail-section-mobile">
              <img width={"100%"} src={thumbnail} alt="Thumbnail" />
            </div>
            <div className="swipe-section">
              <div className="swipe_title_wrapper">
                <h3>PUBLISH YOUR DESIGN</h3>
              </div>
              <div
                style={{
                  gap:
                    window.innerWidth >= 1100 && designStep === 3
                      ? "unset"
                      : "30px",
                }}
                className="swipe-form_wrapper-desk"
              >
                <div className="thumbnail-section">
                  <img
                    style={{
                      display:
                        window.innerWidth >= 1100 && designStep === 3
                          ? "none"
                          : "block",
                    }}
                    width={"100%"}
                    height={"100%"}
                    src={thumbnail}
                    alt="Thumbnail"
                  />
                </div>
                <div className="design_form_wrapper">
                  {designStep === 2 && (
                    <div className="comment">
                      <div style={{ position: "relative" }}>
                        <input
                          className="publish_des_title"
                          type="text"
                          id="title"
                          label="Add Your Title"
                          placeholder="Add Your Title"
                          disabled={isAnonymous}
                          defaultValue={title}
                          onChange={(e) => handleTitleInputChange(e)}
                        />
                      </div>

                      <div style={{ position: "relative" }}>
                        <textarea
                          className="publish_des_comment"
                          id="comment"
                          autoFocus={true}
                          onChange={(e) => setComment(e.target.value)}
                          placeholder="Describe your idea..."
                          label="Describe your idea..."
                          name="comment"
                          multiline
                          rows={6}
                          maxLength={200}
                          defaultValue={comment}
                        ></textarea>
                      </div>
                    </div>
                  )}

                  {designStep === 3 && (
                    <div className="contact-data">
                      <div style={{ position: "relative" }}>
                        <input
                          className="publish_des_age"
                          type="number"
                          id="title"
                          label="*Add"
                          placeholder="Age"
                          disabled={isAnonymous}
                          defaultValue={title}
                          onChange={(e) => handeAgeInputChange(e)}
                        />
                        {ageError && ageError !== "" && (
                          <p className="drawer_form_error">{ageError}</p>
                        )}
                      </div>

                      <div style={{ position: "relative" }}>
                        <select
                          className="publish_des_gender"
                          style={{ minHeight: "42px", width: "100%" }}
                          labelId="sex-label"
                          id="sex"
                          value={sex}
                          label={t("gender")}
                          onChange={(e) => handeSexSelectChange(e)}
                          disabled={isAnonymous}
                        >
                          <option value="" disabled selected hidden>
                            Gender
                          </option>
                          <option value="">{t("none")}</option>
                          <option value="Male">{t("male")}</option>
                          <option value="Female">{t("female")}</option>
                          <option value="Other">{t("other")}</option>
                        </select>
                      </div>

                      <div style={{ position: "relative" }}>
                        <input
                          className="publish_des_email"
                          id="email"
                          onChange={(e) => handeEmailInputChange(e)}
                          placeholder={t("email")}
                          label={t("email")}
                          name="email"
                          defaultValue={email}
                          disabled={isAnonymous}
                        />
                        {emailError && emailError !== "" && (
                          <p className="drawer_form_error">{emailError}</p>
                        )}
                      </div>

                      <div style={{ position: "relative" }}>
                        <input
                          className="publish_des_name"
                          id="name"
                          onChange={(e) => handleNameInputChange(e)}
                          placeholder={t("name")}
                          label={t("name")}
                          name="name"
                          defaultValue={name}
                          disabled={isAnonymous}
                        />
                      </div>
                    </div>
                  )}

                  <div className="design-navigation">
                    <button
                      className="prev cancel_button_gray"
                      onClick={() => onClickPrevStep()}
                    >
                      {t("cancel")}
                    </button>
                    {designStep !== maxStep - 1 && (
                      <button
                        className="next ok_button_success"
                        onClick={() => onClickNextStep()}
                        disabled={disabledNextBtn}
                      >
                        {"Next"}
                      </button>
                    )}
                    {designStep === maxStep - 1 && (
                      <button
                        className="next ok_button_success"
                        onClick={() => handleCreateDesign()}
                        disabled={disabledPublishBtn}
                      >
                        {t("publish")}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Drawer>
        </div>
      )}
      <Dialog
        open={openInfoDialog}
        onClose={() => setOpenInfoDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="custom_cancel_dialog"
        PaperProps={{
          sx: {
            width: "381px",
            height: "407px",
            borderRadius: "20px",
            background: "#FFF",
            overflow: "hidden",
            padding: 0
          }
        }}
        sx={{
          textAlign: "left",
        }}
      >
        <DialogTitle
          sx={{
            width: "283px",
            height: "33px",
            color: "#000",
            fontFamily: "Manrope",
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "normal",
            textTransform: "uppercase",
            textAlign: "left",
            marginTop: "40px",
            marginLeft: "39px",
            marginRight: "59px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            padding: "0"
          }}
        >
          {currentSelectedImageElement?.title}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setOpenInfoDialog(false)}
          sx={{
            position: "absolute",
            top: "20px",
            right: "20px",
            width: "14px",
            height: "14px",
            padding: "2px",
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon sx={{ fontSize: "28px" }} />
        </IconButton>

        <DialogContent
          sx={{
            width: "282px",
            minWidth: "282px",
            minHeight: "204px",
            maxHeight: "204px",
            color: "#000",
            fontFamily: "Manrope",
            fontSize: "18px",
            lineHeight: "normal",
            fontStyle: "normal",
            marginLeft: "40px",
            marginTop: "12px",
            overflowY: "auto",
            marginRight: "40px",
            padding: "0",
            paddingRight: "13px",
            "&::-webkit-scrollbar": {
              width: "6px",
              maxHeight: "151px"
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#C1C1C1",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#EAEAEA",
              borderRadius: "10px",
            },
            "&::-webkit-crollbar-thumb": {
              backgroundColor: "#9999999"
            }
          }}
        >
          {currentSelectedImageElement?.description}
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "left",  // Centers the button
            marginTop: "20px",
            marginBottom: "40px",
            marginLeft: "40px",
            padding: "0"
          }}
        >
          {currentSelectedImageElement?.link && (
            <Button
              className="dialog_cancel_btn"
              onClick={navigateToProduct}
              variant="text"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "100px",
                background: "#06C067",
                width: "221px",
                height: "58px",
                ":hover": {
                  background: "#06C067",
                },
              }}
            >
              <span style={{
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Manrope",
                fontSize: "22px",
                fontWeight: "700",
                textTransform: "none"
              }}>
                View Product
              </span>
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default CreateDesign;
